<template>
    <div class="dd5">
        <div class="dd5_copyright" style="position: relative"><a href="https://bszs.conac.cn/sitename?method=show&id=54414D6082843FDFE053022819ACA6F1" target="_blank"><img src="../assets/img/dzjg.png" style="position: absolute;
    bottom: -15px;
    left: calc(50% - 530px)"/></a>
          主办单位：{{footOrganizer.value}}　　　技术支持：{{footSupport.value}}<br/>
          联系电话：0730-8880641　　　网站标识码: 4306000069　　　<a href="http://beian.miit.gov.cn/" target="_blank" style="color: #FFFFFF">湘ICP备09024640号</a>
          　　　<a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank" style="color: #FFFFFF;margin-left: 40px">湘公网安备: 43060202000064号</a><br/>
          <!--                技术咨询服务电话： 0731-85240266 150-7333-7666（庞先生）-->
          <a href="https://zfwzgl.www.gov.cn/exposure/jiucuo.html?site_code=4306000069&url=http%3A%2F%2Fcredit.yueyang.gov.cn%2Findex.html" target="_blank"><img src="../assets/img/zfjc.png" style="position: absolute;
    bottom: 0px;
    left: calc(50% + 450px)"/></a>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    export default {
        name: 'myFooter',
        computed: {
            ...mapGetters(["footOrganizer", "footSupport"])
        }
    }
</script>

<style scoped lang="less">
    .dd5{
        position: relative;
        bottom: 0;
        height: 90px;
        width: 100%;
        background: #383d41;
    }
    .dd5_copyright{
        color: #fff;
        font-size: 14px;
        line-height: 25px;
        text-align: center;
        padding-top: 18px;
    }
</style>
